export default "__VITE_ASSET__kAL8u0Zk__"